export const iconFontAwesomeCommunicationVideo = (
	<i className="fa-solid fa-video"></i>
);
